<app-navbar title="Baza wycieczek">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-resident-base-trip-list-filter
	userFilters="residentTripList"
	[destinations]="parameters.destinations"
	(selected)="filtersSelected($event)"
>
</app-resident-base-trip-list-filter>

<app-dynamic-table
	module="residentBaseTrips"
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
